import filtersActions from '../constants/filtersActionConstants';

const initialState = {
  contactFilters: {
    referrals_sent: '',
    tags: [],
    sources: [],
    starred: false,
  },
  disputeFilters: {
    statuses: [],
    openings: [],
    company_names: [],
    candidate_names: [],
    start_date: '',
    end_date: '',
    min_amount: '',
    max_amount: '',
    experiential_rewards: [],
  },
  filterDropdownValues: {
    functions: [],
    industries: [],
    opportunityTypes: [],
    workTypes: [],
    experienceLevels: [],
    requiredEducation: [],
    remoteWork: [],
  },
};

const filtersReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case filtersActions.SET_CONTACT_FILTERS:
      return {
        ...state,
        contactFilters: action.payload,
      };
    case filtersActions.SET_DISPUTE_FILTERS:
      return {
        ...state,
        disputeFilters: action.payload,
      };
    case filtersActions.SET_FILTER_DROPDOWN_VALUES:
      return {
        ...state,
        filterDropdownValues: {
          ...state.filterDropdownValues,
          functions: action.payload.metadata.function_types,
          industries: action.payload.metadata.job_industries,
          opportunityTypes: action.payload.metadata.work_types,
          workTypes: action.payload.metadata.work_place_types,
          experienceLevels: action.payload.metadata.job_experiences,
          requiredEducation: action.payload.metadata.job_educations,
          remoteWork: action.payload.metadata.job_urgency_types,
          organizationLocations: action.payload.metadata.job_locations,
        },
      };
    default:
      return state;
  }
};

export default filtersReducer;
